import { render } from "./noticeBar.vue?vue&type=template&id=04e72688&scoped=true"
import script from "./noticeBar.vue?vue&type=script&lang=js"
export * from "./noticeBar.vue?vue&type=script&lang=js"

import "./noticeBar.vue?vue&type=style&index=0&id=04e72688&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-04e72688"

export default script